import { Component } from '@angular/core';

import {
  InputImageComponent,
  InputImagesComponent,
  InputPhoneComponent,
  InputSchemaComponent,
  WysiswygComponent,
} from '@camelot/form-input';
import { InputImages, InputPhone, InputSchema, InputWysiswyg } from '@camelot/form-model';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [
        InputImageComponent,
        InputImagesComponent,
        InputPhoneComponent,
        InputSchemaComponent,
        TestIdDirective,
        WysiswygComponent,
    ],
    template: `
    <cam-input-images camTestId="cam-input-images" [input]="this.images" [standalone]="true" />
    <cam-input-image camTestId="cam-input-image" [input]="this.image" [standalone]="true" />
    <cam-input-schema camTestId="cam-input-schema" [input]="this.schema" [standalone]="true" />
    <cam-input-phone camTestId="cam-input-phone" [input]="this.phone" [standalone]="true" />
    <cam-input-wysiswyg camTestId="cam-input-wysiswyg" [input]="this.wysiswyg" [standalone]="true" />
  `
})
export class FormInputsMediaCase {
  public image = new InputImages({ controlType: 'image', key: 'image', label: 'Image' });
  public images = new InputImages({ key: 'images', label: 'Images' });
  public phone = new InputPhone({ key: 'phone', label: 'Phone' });
  public schema = new InputSchema({ key: 'schema', label: 'Schema' });
  public wysiswyg = new InputWysiswyg({ key: 'wysiswyg', label: 'Wysiswyg' });
}
